import AlertWordsComponent from '@/components/user-settings/_components/alert-words';
import CMChatColourComponent from '@/components/user-settings/_components/cm-chat-colour';
import CMMessageColourComponent from '@/components/user-settings/_components/cm-message-colour';
import WindowLayoutComponent from '@/components/user-settings/_components/window-layout';
import ChatTimestampsComponent from '@/components/user-settings/_components/chat-timestamps';
import JackpotBroadcastsComponent from '@/components/user-settings/_components/jackpot-broadcasts';
import ChatFontSizeComponent from '@/components/user-settings/_components/chat-font-size';
import BoldFontComponent from '@/components/user-settings/_components/bold-font';
import NotificationSoundComponent from '@/components/user-settings/_components/notification-sound';
import CMMessageColourInternationalComponent from './cm-message-colour-international/cm-message-colour.vue';
import NotificationPositionComponent from '@/components/user-settings/_components/notification-position';
import ColourThemeComponent from '@/components/user-settings/_components/colour-theme';
import PinNavigationMenuComponent from '@/components/user-settings/_components/pin-navigation-menu';
import DeveloperComponent from '@/components/user-settings/_components/developer';


export default {
  alertWords: AlertWordsComponent,
  cmChatColour: CMChatColourComponent,
  windowLayout: WindowLayoutComponent,
  cmMessageColour: CMMessageColourComponent,
  cmMessageColourInternational: CMMessageColourInternationalComponent,
  chatTimestamps: ChatTimestampsComponent,
  jackpotBroadcasts: JackpotBroadcastsComponent,
  chatFontSize: ChatFontSizeComponent,
  boldFont: BoldFontComponent,
  notificationSound: NotificationSoundComponent,
  notificationPosition: NotificationPositionComponent,
  colourTheme: ColourThemeComponent,
  pinNavigationMenu: PinNavigationMenuComponent,
  developer: DeveloperComponent
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/user-settings/_components/index.ts